var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueApexCharts',{attrs:{"type":"bar","height":"620","options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }